module.exports = __webpack_public_path__ + "img/04.ff7ced41.png";